import React from "react";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";

function PaginationControls({ currentPage, totalPages, onPageChange }) {

  function renderPaginationItems() {
    const paginationItems = [];
    const maxDisplayedPages = 3;

    let startPage, endPage;

    if (totalPages <= maxDisplayedPages + 2) {
      startPage = 1;
      endPage = totalPages;
    } else {
      if (currentPage <= Math.ceil(maxDisplayedPages / 2)) {
        startPage = 1;
        endPage = maxDisplayedPages;
      } else if (currentPage + Math.floor(maxDisplayedPages / 2) >= totalPages) {
        startPage = totalPages - maxDisplayedPages + 1;
        endPage = totalPages;
      } else {
        startPage = currentPage - Math.floor(maxDisplayedPages / 2);
        endPage = currentPage + Math.floor(maxDisplayedPages / 2);
      }
    }

    // Add the first page and ellipsis if needed
    if (startPage > 1) {
      paginationItems.push(
        <PaginationItem key={1} active={currentPage === 1}>
          <PaginationLink onClick={() => onPageChange(1)}>
            1
          </PaginationLink>
        </PaginationItem>
      );
      if (startPage > 2) {
        paginationItems.push(
          <PaginationItem key="start-ellipsis" disabled>
            <PaginationLink>...</PaginationLink>
          </PaginationItem>
        );
      }
    }

    // Add the range of pages
    for (let i = startPage; i <= endPage; i++) {
      paginationItems.push(
        <PaginationItem key={i} active={i === currentPage}>
          <PaginationLink onClick={() => onPageChange(i)}>
            {i}
          </PaginationLink>
        </PaginationItem>
      );
    }

    // Add the last page and ellipsis if needed
    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        paginationItems.push(
          <PaginationItem key="end-ellipsis" disabled>
            <PaginationLink>...</PaginationLink>
          </PaginationItem>
        );
      }
      paginationItems.push(
        <PaginationItem key={totalPages} active={currentPage === totalPages}>
          <PaginationLink onClick={() => onPageChange(totalPages)}>
            {totalPages}
          </PaginationLink>
        </PaginationItem>
      );
    }
    return paginationItems;
  };

  return (
    <Pagination data-testid="pagination-controls">
      <PaginationItem disabled={currentPage === 1}>
        <PaginationLink
          first
          onClick={() => {
            if (currentPage === 1) return;
            onPageChange(1);
          }}
        />
      </PaginationItem>
      <PaginationItem disabled={currentPage === 1}>
        <PaginationLink
          previous
          onClick={() => {
            if (currentPage === 1) return;
            onPageChange(currentPage - 1);
          }}
        />
      </PaginationItem>

      {renderPaginationItems()}

      <PaginationItem disabled={currentPage === totalPages}>
        <PaginationLink
          next
          onClick={() => {
            if (currentPage === totalPages) return;
            onPageChange(currentPage + 1);
          }}
        />
      </PaginationItem>
      <PaginationItem disabled={currentPage === totalPages}>
        <PaginationLink
          last
          onClick={() => {
            if (currentPage === totalPages) return;
            onPageChange(totalPages);
          }}
        />
      </PaginationItem>
    </Pagination>
  );
}

export default PaginationControls;